import React, { useState } from 'react';
import { download_welcome_kit, fetchServiceRequestStatusApiCallFun } from '../../Global/Index';
import { toast } from 'react-toastify';
import BeatLoader from 'react-spinners/BeatLoader';
import { useTheme } from '@mui/material';
import { TbSend } from 'react-icons/tb';

const override = {
  margin: "0 auto",
  marginLeft: '.3vw'
};


const Download_Welcome_Kit = () => {

  const [submitloader, setSubmitloader] = useState(false);
  const [request, setRequest] = useState(false);
  const theme = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitloader(true);
    let requestStatus = 'Pending';

    try {
      const serviceRequestStatusApiResponse = await fetchServiceRequestStatusApiCallFun();
      if (serviceRequestStatusApiResponse.response.status == "200" && serviceRequestStatusApiResponse.response.message == 'Success') {
        const activeloanstatus = serviceRequestStatusApiResponse.response.data;
        const filteredRequests = activeloanstatus.filter(
          item => item.requestName === 'Welcome Letter',
        );

        if (filteredRequests.length > 0) {
          // Sort by createDate in descending order and get the first (latest) item
          const latestRequest = filteredRequests.sort(
            (a, b) => new Date(b.createDate) - new Date(a.createDate),
          )[0];

          if (
            latestRequest.requestName == 'Welcome Letter' &&
            latestRequest.welcomeKitUrl != null &&
            latestRequest.MITCDocumentUrl != null &&
            latestRequest.ScheduleOfChargeUrl != null
          ) {
            requestStatus = 'Closed'
          }
        } else {
          toast.error('Something went wrong. Please try again later!')
        }
      }

      const downloadWelcomeKitRequestResponse = await download_welcome_kit(requestStatus);
      if (downloadWelcomeKitRequestResponse.response.status === "200" && downloadWelcomeKitRequestResponse.response.message === 'Success') {
        toast.success('Request has been successfully submitted');
        setRequest(true);
      } else if (downloadWelcomeKitRequestResponse.response.status === "419") {
        window.location.href = '/Session-Expired'
      } else if (downloadWelcomeKitRequestResponse.response.status === "500") {
        toast.error('Something went wrong. Please try again later!')
      } else if (downloadWelcomeKitRequestResponse.response.status === "503") {
        toast.warn(downloadWelcomeKitRequestResponse.response.message);
      } else if (downloadWelcomeKitRequestResponse.response.status == '401') {
        window.location.href = '/'
      }
      setSubmitloader(false);
    } catch (error) {
      toast.error('Something went wrong. Please try again later!');
      console.log(error?.message || 'An error occurred');
    }

  }


  return (
    <>

      {
        !request ? <div className="download-welcome-kit">
          <h3>Generate Your Welcome Kit</h3>
          <p>Click the button below to download your welcome kit.</p>

          <button
            type="submit"
            onClick={handleSubmit}
            className='downloadbutton'
            disabled={submitloader}
            style={{
              margin: '1vw auto',
              background: theme.palette.maincolor.buttoncolor,
              color: theme.palette.maincolor.light,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem'
            }}
          >
            {submitloader ? (
              <>
                <span>Processing</span>
                <BeatLoader
                  color="rgb(155,57,19)"
                  loading={submitloader}
                  cssOverride={override}
                  size={6}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </>
            ) : (
              <>
                <TbSend size={20} />
                <span>Download Welcome Kit </span>
              </>
            )}
          </button>
        </div> : (
          <div className="download-welcome-kit">
            <p>Your request has been raised successfully. Please check status for Tracking status.</p>
          </div>)
      }
    </>
  );
};

export default Download_Welcome_Kit